<template>
  <div class="">
    <!-- model: {{ currentModel }} -->
    <!-- {{ cart }} -->

    <!-- <div class="ct-sticky-container" style="height: 121px;">
      <div data-sticky="fixed:shrink">
        <div data-row="middle" data-column-set="2" data-transparent-row="yes">
          <div class="ct-container">
            <div data-column="start" data-placements="1">
              <div data-items="primary">
                <div
                  class="site-branding"
                  data-id="logo"
                  itemscope="itemscope"
                  itemtype="https://schema.org/Organization"
                >
                  <a
                    href="https://moverai.com/"
                    class="site-logo-container"
                    rel="home"
                    ><img
                      width="2000"
                      height="378"
                      src="https://moverai.com/wp-content/uploads/2024/02/moverai-high-resolution-logo-color-on-transparent-background-2.png"
                      class="default-logo"
                      alt="MoverAI"
                  /></a>
                </div>

                <nav
                  id="header-menu-1"
                  class="header-menu-1"
                  data-id="menu"
                  data-interaction="hover"
                  data-menu="type-1"
                  data-dropdown="type-1:simple"
                  data-responsive="yes"
                  itemscope=""
                  itemtype="https://schema.org/SiteNavigationElement"
                  aria-label="Header Menu"
                ></nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <v-toolbar class="cart-tool" flat>
      <WebSiteHeader></WebSiteHeader>
    </v-toolbar> -->
    <v-card flat class="pa-2" v-if="userId">
      <VCreditCardForm
        :amount="amount"
        :priceModel="dataObject.model"
        :itemDescription="caption"
        submitCaption="Subscribe"
      ></VCreditCardForm>
    </v-card>
    <v-form-card
      v-if="!userId && modelReady"
      :key="formKey"
      flat
      :dObject="dataObject"
      :elevation="10"
      formClass="ma-2"
      :caption="caption"
      :steppers="steppers"
      :mainTabs="mainTabs"
    >
    </v-form-card>
  </div>
</template>

<script>
import * as fun from "../plugins/common";

import axios from "axios";

export default {
  name: "CreateAccount",
  components: {
    VFormComponent: () => import("../components/FormComponent.vue"),
    VFormCard: () => import("../components/FormCard.vue"),
    WebSiteHeader: () => import("../components/UI/WebSiteHeader.vue"),
    VCreditCardForm: () => import("../components/StripeForm.vue"),
  },
  props: {},
  data() {
    return {
      testData: {
        first_name: "test",
        last_name: "mover",
        login: "georgefreed@gmail.com",
        password: "123abc",
        company_name: "Moving test inc",
        email: "mover@moverai.com",
        domain_name: "moverai.com",
        address: {
          address: {
            title: "123 Vineyard Ave",
            address: "123 Vineyard Ave, Yonkers, NY 10703",
            value: "<b>123</b> Vineyard Ave, Yonkers, NY 10703",
            geo: {
              name: "123 Vineyard Ave",
              location: {
                position: [40.94404, -73.8865],
                address: {
                  text: "123 Vineyard Ave<br/>Yonkers, NY 10703-2854<br/>USA",
                  house: "123",
                  street: "Vineyard Ave",
                  postalCode: "10703-2854",
                  district: "Getty Square",
                  city: "Yonkers",
                  county: "Westchester",
                  state: "New York",
                  stateCode: "NY",
                  country: "United States",
                  countryCode: "USA",
                },
                bbox: [-73.8883, 40.93936, -73.88552, 40.94555],
              },
            },
          },
        },
        phones: {
          office: { phone_type: "office", phone_number: "2125555555" },
        },
        charge_option: "annually",
        // credit_card: {
        card_number: "4111111111111111",
        card_expire: "02/25",
        cvv2: "123",
        // },
      },
      initialData: {
        address: {},
        phones: {
          office: {},
        },
        charge_option: "annually",
      },
      amount: 0,
      userId: null,
      summary: "",
      caption: "",
      cart: [],
      formKey: 0,
      modelReady: false,
      currentModel: null,
      currentSchema: null,
      dataObject: {
        object_name: "portal_settings",
      },
      steppers: [],
      password: "",
      confirmPassword: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 6 || "Password must be at least 6 characters", // You can add additional rules as needed
      ],
      confirmPasswordRules: [
        (v) => !!v || "Confirm Password is required",
        (v) => v === this.password || "Passwords must match",
      ],
      testModel: {},
      trial: false,
    };
  },
  mounted() {
    // this.test();
    var that = this;
    if (localStorage.getItem("cart")) {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      // this.calculateCart();
    }
    console.log(this.$route.params.id);
    console.log(this.cart);
    this.$root.$on("stepsCompleted", (s) => {
      // var frm = fun.getParentByProperty(s.obj, "dObject");
      // var form = frm.$refs["form"];
      // console.log(form.listFormInputs());
      // // form.$refs["form"].validate();

      var btn = s.obj.$refs.stepSubmit[s.step];
      s.obj.model.packages = this.cart;
      btn.loading = true;

      // console.log(s);
      axios
        .post(that.serverURL + "/create_account", s.obj.model)
        .then((response) => {
          console.log(response.data);
          btn.loading = false;
          var newPortalId = response.data;

          var newURL = "/login/" + newPortalId;
          this.$router.push(newURL);
          this.$router.go({
            path: newURL,
          });
          that.$router.go({
            path: newURL,
          });
        });
    });
    this.$root.$on("addressChanged", (s) => {
      this.formKey = !this.formKey;
    });
    //addressChanged
    var data = {
      object_name: "create_account",
      all_records: true,
    };
    axios.post(this.serverURL + "/get_setup_schema", data).then((response) => {
      that.currentModel = { _id: fun.guid() };
      that.currentModel.phones = {
        office: {},
      };
      that.currentModel.address = {};

      that.userId = this.$route.params.id;
      // ? true : false;
      that.dataObject.schema = response.data;

      // that.currentModel;

      that.currentSchema = response.data.properties;
      that.steppers = response.data.steppers;
      if (that.trial) {
        that.steppers = that.steppers.filter((s) => {
          return s.name != "credit_card_info";
        });
        that.steppers[1].btn.caption = "Start Your Trial";
      }
      that.mainTabs = response.data.mainTabs;

      that.calculateCart();
    });
  },
  beforeDestroy() {},
  methods: {
    test() {
      var newPortalId = 325;
      var newURL = "";
      if (this.serverURL.includes("moverai.com")) {
        newURL = "https://portal_" + newPortalId + ".moverai.com";
      } else {
        newURL = "http://localhost:8080/#/portal_" + newPortalId;
      }
      // window.location.href = newURL;
      this.$router.push({ path: newURL });
      this.$router.go({
        path: newURL,
      });
    },
    getSaving(totalMonthly, total) {
      return parseInt((100 * (totalMonthly - total)) / totalMonthly);
    },
    calculateCart() {
      this.summary = "";
      var qty = 0;
      var totalMonthly = 0;
      var totalAnnually = 0;
      var totalQuarterly = 0;
      var totalSemiAnnually = 0;
      var myItems = [];
      this.cart.forEach((c) => {
        qty += parseInt(c.qty);
        var description = fun.capitalize(c.package_name);
        var p = c.users ? " package " : "(s) ";
        myItems.push(c.qty + " " + description + p);
        this.summary = myItems.join(" + ");
        totalAnnually += parseFloat(c.annually) * c.qty;
        totalMonthly += parseFloat(c.monthly) * c.qty;
        totalQuarterly += parseFloat(c.quarterly) * c.qty;
        totalSemiAnnually += parseFloat(c.semiannually) * c.qty;
      });
      if (this.userId) {
        this.caption = "Subscribe: " + this.summary;
      } else {
        this.caption = "Create New Account: " + this.summary;
      }

      // totalAnnualy = totalAnnualy * 12;

      // this.dataObject.model.charge = this.dataObject.model.total_annualy;
      this.currentModel = this.initialData;
      // this.currentModel = this.testData;
      //

      this.currentModel.total_annually = totalAnnually * 12;
      this.currentModel.total_monthly = totalMonthly;
      this.currentModel.total_semiannually = totalSemiAnnually * 6;
      this.currentModel.total_quarterly = totalQuarterly * 3;

      // var saving = parseInt(
      //   (100 * (totalMonthly - totalAnnualy)) / totalMonthly
      // );
      this.currentSchema.charge_option["v-bind"].items = [
        {
          value: "annually",
          text:
            "Annualy: " +
            fun.formatCurrency(totalAnnually, "USD") +
            " x 12 = " +
            fun.formatCurrency(this.currentModel.total_annually, "USD") +
            " (" +
            this.getSaving(totalMonthly, totalAnnually) +
            "% saving)",
        },

        {
          value: "semiannualy",
          text:
            "Semi-Annualy: " +
            fun.formatCurrency(totalSemiAnnually, "USD") +
            " x 6 = " +
            fun.formatCurrency(this.currentModel.total_semiannually, "USD") +
            " (" +
            this.getSaving(totalMonthly, totalSemiAnnually) +
            "% saving)",
        },
        {
          value: "quarterly",
          text:
            "Quarterly: " +
            fun.formatCurrency(totalQuarterly, "USD") +
            " x 4 = " +
            fun.formatCurrency(this.currentModel.total_quarterly, "USD") +
            " (" +
            this.getSaving(totalMonthly, totalQuarterly) +
            "% saving)",
        },
        {
          value: "monthly",
          text:
            "Monthly: " +
            fun.formatCurrency(this.currentModel.total_monthly, "USD"),
        },
      ];
      // this.currentModel.charge_option = "annually";
      this.dataObject.model = this.currentModel;

      this.modelReady = true;
    },
  },
};
</script>

<style lang="css">
.full-width .v-card {
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
}
.full-width {
  width: 80vw;
}

@media only screen and (max-width: 600px) {
  .full-width {
    width: 100vw;
  }
}
</style>
